import { useCallback } from "react";
import { EmailRegex } from "@rinastyling/common";
import useInput from "../hooks/useInput";
import useRequiredFields from "../hooks/useRequiredFields";
import TitleWithBorder from "./TitleWithBorder";
import { Button } from "./core/Button";
import { Form } from "./core/Form";
import { AuthService } from "../services/AuthService";
import { handleFetchError } from "../utils/clientErrorHandeling";
import { toast } from "react-toastify";
import { usePopover } from "../hooks/usePopover";

const ForgotPasswordForm = () => {
  const { hidePopover } = usePopover();
  const emailInput = useInput({
    initalValue: "",
    type: "text",
    regex: EmailRegex,
    label: "אימייל"
  });
  const disabled = useRequiredFields([emailInput]);

  const handleSubmit = useCallback(async () => {
    try {
      const res = await new AuthService().forgetPasswordRequest({
        email: emailInput.value
      });
      toast(res.msg);
    } catch (error) {
      handleFetchError(error);
    } finally {
      hidePopover();
    }
  }, [emailInput.value, hidePopover]);

  return (
    <Form>
      <TitleWithBorder text="שיחזור סיסמא" />
      {emailInput.jsx}
      <Button disabled={disabled} onClick={handleSubmit}>
        שליחה
      </Button>
    </Form>
  );
};

export default ForgotPasswordForm;
